var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTextarea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 25,
    viewBox: "0 0 36 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1374_22072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.96338 18.2983V5.6594C2.96338 5.53968 3.05892 5.42487 3.229 5.34022C3.39907 5.25556 3.62973 5.20801 3.87025 5.20801H32.2856C32.5261 5.20801 32.7567 5.25556 32.9268 5.34022C33.0969 5.42487 33.1924 5.53968 33.1924 5.6594V18.2983C33.1924 18.418 33.0969 18.5328 32.9268 18.6175C32.7567 18.7021 32.5261 18.7497 32.2856 18.7497H3.87025C3.62973 18.7497 3.39907 18.7021 3.229 18.6175C3.05892 18.5328 2.96338 18.418 2.96338 18.2983Z",
    fill: "#DCA11C",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77832 13.5413V11.458H4.74195V13.5413H1.77832ZM31.4147 13.5413V11.458H34.3783V13.5413H31.4147Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0039 9.375H19.5603H23.1166",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0039 14.583H17.7821H19.5603",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0039 11.9795H22.6721H27.1175",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00195 9.375H10.6692H13.3365",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6694 10.417V12.5003V14.5837",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1374_22072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.5636,
    height: 25,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextarea);
export default __webpack_public_path__ + "static/media/textarea.8ae8e00001a97630a1bcd9e31f412505.svg";
export { ForwardRef as ReactComponent };